function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var module;
// LICENSE_CODE ZON
'use strict'; /*jslint node:true, react:true*/

var is_node = typeof module == 'object' && module.exports;
if (is_node) ;else ;
define(['react', 'react-dom', 'virt_jquery_all', '/www/hola/pub/react_util.js', 'classnames'], function (React, ReactDOM, $, react_util, cn) {
  var E = {};
  var useState = React.useState,
    useEffect = React.useEffect,
    Fragment = React.Fragment,
    useRef = React.useRef,
    useMemo = React.useMemo;
  var Modal = props => {
    var _useState = useState(props.show),
      _useState2 = _slicedToArray(_useState, 2),
      show = _useState2[0],
      set_show = _useState2[1];
    var state = useMemo(() => ({}), []);
    var ref_root = useRef(null);
    var dom_in = () => {
      if (state.dom) {
        state.dom.style.display = 'block';
        state.dom.style.paddingLeft = '0px';
        var body = document.body;
        body.classList.add('modal-open');
        setTimeout(() => {
          state.dom.classList.add('in');
        }, 200);
      }
    };
    useEffect(() => {
      if (props.show != show) set_show(props.show);
      var body = document.body;
      if (props.show) dom_in();else {
        if (state.dom) state.dom.classList.remove('in');
        setTimeout(() => {
          body.classList.remove('modal-open');
        }, 0);
      }
    }, [props.show]);
    var on_back_click = event => {
      if (props.backdrop === true) props.on_close();else event.stopPropagation();
    };
    useEffect(() => {
      var on_close_hdl = () => props.on_close();
      var on_keyboard = event => {
        if (event.keyCode == 27 && props.keyboard !== false) props.on_close();
      };
      if (ref_root && ref_root.current) {
        var dom = ref_root.current;
        dom.addEventListener('modal_close', on_close_hdl);
        document.addEventListener('keydown', on_keyboard);
        state.dom = dom;
        if (props.show) dom_in();
        return () => {
          dom.removeEventListener('modal_close', on_close_hdl);
          document.removeEventListener('keydown', on_keyboard);
        };
      }
    }, []);
    return /*#__PURE__*/React.createElement(Fragment, null, props.backdrop && /*#__PURE__*/React.createElement("div", {
      className: "modal-backdrop fade in"
    }), /*#__PURE__*/React.createElement("div", {
      className: cn(props.cls, 'modal fade'),
      tabIndex: -1,
      onClick: on_back_click,
      ref: ref_root
    }, /*#__PURE__*/React.createElement("div", {
      className: "modal-dialog",
      onClick: event => event.stopPropagation()
    }, /*#__PURE__*/React.createElement("div", {
      className: "modal-content"
    }, props.children))));
  };
  var Header = props => {
    var send_close = ev => {
      ev.target.dispatchEvent(new Event('modal_close', {
        bubbles: true
      }));
    };
    var label = '×';
    return /*#__PURE__*/React.createElement("div", {
      className: "modal-header"
    }, props.close_button && /*#__PURE__*/React.createElement("button", {
      type: "button",
      className: "close",
      onClick: send_close
    }, /*#__PURE__*/React.createElement("span", {
      "aria-hidden": "true"
    }, label), /*#__PURE__*/React.createElement("span", {
      className: "sr-only"
    }, "Close")), props.children);
  };
  class Iframe_modal extends React.PureComponent {
    constructor(...props) {
      super(...props);
      // XXX sergey: shold be different for different modals
      this._id = 'iframe_modal';
      for (var _i = 0, _arr = ['show', 'close']; _i < _arr.length; _i++) {
        var k = _arr[_i];
        this[k] = this[k].bind(this);
      }
    }
    componentDidMount() {
      var _this$_form;
      (_this$_form = this._form) === null || _this$_form === void 0 ? void 0 : _this$_form.submit();
    }
    show() {
      this.setState({
        show: true
      });
    }
    close() {
      this.setState({
        show: false
      });
      if (this.props.on_close) this.props.on_close();
    }
    get_form() {
      if (!this.props.form) return null;
      var _this$props$form = this.props.form,
        action = _this$props$form.action,
        method = _this$props$form.method,
        data = _this$props$form.data;
      var inputs = Object.keys(data).map(f => /*#__PURE__*/React.createElement("input", {
        key: f,
        type: "hidden",
        name: f,
        value: data[f]
      }));
      return /*#__PURE__*/React.createElement("form", {
        ref: _ref => {
          this._form = _ref;
        },
        target: this._id,
        action: action,
        method: method
      }, inputs);
    }
    render() {
      var props = this.props,
        _id = this._id;
      return /*#__PURE__*/React.createElement(Modal, {
        on_close: this.close,
        show: this.show,
        backdrop: props.no_bg_close ? 'static' : true,
        keyboard: props.no_kb_close ? false : true
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-body"
      }, this.get_form(), /*#__PURE__*/React.createElement("iframe", {
        frameBorder: "0",
        height: props.height || '100%',
        width: "100%",
        id: _id,
        name: _id,
        scrolling: "no",
        src: props.url
      })));
    }
  }
  var open_remote_modal = opt => {
    var el = document.createElement('div');
    el.className = 'remote-modal-root';
    document.body.appendChild(el);
    var win_height = window.innerHeight;
    var height = Math.min(640, win_height);
    var close = () => {
      ReactDOM.unmountComponentAtNode(el);
      el.remove();
    };
    var on_close = () => {
      if (opt.on_cancel) opt.on_cancel();
      // with delay to let modal to finish the close animation
      setTimeout(close, 500);
    };
    react_util.dom_render(/*#__PURE__*/React.createElement(Iframe_modal, _extends({
      on_close: on_close,
      height: height
    }, opt)), el);
    return {
      close
    };
  };
  E = {
    open_remote_modal,
    Modal,
    Header
  };
  return E;
});